<script lang="ts">
  import type { ToastStore } from '../stores/toast.svelte';

  interface Properties {
    /** Store to observe — usually the page-wide singleton exported from `stores/toast.svelte`. */
    store: ToastStore;
  }

  const { store }: Properties = $props();

  /** Dismisses the current message via the store's own timer-cancelling API. */
  function handleDismiss(): void {
    store.dismiss();
  }
</script>

<!-- Global error toast. Rendered fixed-top so failures from silent-swallow
     paths (autocomplete fetchers, background hydrators) are visible even
     when the sidebar / active tab has no error banner of its own. -->
{#if store.message}
  <div class="toast" role="alert" aria-live="assertive">
    <span class="toast-message">{store.message}</span>
    <button type="button" class="toast-close" onclick={handleDismiss} aria-label="Dismiss">
      ×
    </button>
  </div>
{/if}

<style>
  .toast {
    position: fixed;
    top: var(--space-md);
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    max-width: min(90vw, 640px);
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    background: rgb(248 81 73 / 15%);
    border: 1px solid var(--color-accent-red);
    color: var(--color-accent-red);
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--radius-sm);
    font-size: var(--font-size-sm);
    box-shadow: 0 4px 12px rgb(0 0 0 / 30%);
  }

  .toast-message {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .toast-close {
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: var(--font-size-lg);
    line-height: 1;
    padding: 0 var(--space-xs);
  }

  .toast-close:hover {
    color: var(--color-fg);
  }
</style>
